import register from '../register';
import dom from './util/dom';
import {
  validateEmail,
  validatePhone,
  addError,
  removeError,
  isEmpty,
  isNotSubmit,
  shouldValidate
} from './util/form-utils';
import phoneMask from './util/phone-mask';
import jump from './util/jump';

let $ = document.querySelector.bind( document );

let $form;
let $inputs;
let $phone;
let $name;
let $email;
let $submit;
let $error;
let $phoneError;
let $self;
let $thanks;
let $banner;

let validators = {
  email: validateEmail,
  phone: validatePhone
};

function init() {
  $form = $('#management-referral-form');
  $inputs = [ ...$form.querySelectorAll('input:not([type="radio"]), select') ];
  $phone = $form.querySelector('#inp-phone');
  $name = $form.querySelector('#inp-name');
  $email = $form.querySelector('#inp-email-address');
  $submit = $form.querySelector('#inp-submit');
  $error = $('.management-form .submit-error');
  $phoneError = $form.querySelector('.phone-or-email-error');
  $self = $('.management-form');
  $thanks = $('.thanks');

  $form.addEventListener( 'submit', onSubmit );
  phoneMask( $phone );

  [ $phone, $email, $name ].forEach( input => {
    input.addEventListener( 'keyup', () => {
      $submit.disabled = shouldDisableSubmit();
    });
  });
}

function shouldDisableSubmit() {
  return ( !$name.value || ( !$phone.value && !$email.value ) );
}

function onSubmit( e ) {
  e.preventDefault();

  let payload;

  if ( validate() && emailOrPhone() ) {
    $submit.disabled = true;
    $submit.classList.add('loading');
    payload = getPayload();
    submitForm( payload );
  }
}

function emailOrPhone() {

  togglePhoneOrEmailError( false );

  let hasEmail = !!$email.value;
  let hasPhone = !!$phone.value;
  let validEmail;
  let validPhone;

  if ( !hasEmail && !hasPhone ) {
    return false;
  }

  if ( hasEmail ) {
    validEmail = validateInput( $email );
  }

  if ( hasPhone ) {
    validPhone = validateInput( $phone );
  }

  if ( validEmail || validPhone ) {
    return true;
  }

  togglePhoneOrEmailError( true );
  return false;
}

function togglePhoneOrEmailError( bool ) {
  if ( bool ) {
    $phoneError.classList.add('error');
    return;
  }
  $phoneError.classList.remove('error');
}

function validateInput( input ) {
  let { name, value } = input;
  let validator = validators[ name ];

  let isValid = validator( value );

  if ( !isValid ) {
    return false;
  }

  return true;
}

function submitForm( payload ) {
  let opts = {
    url: '/api/referred-decision-makers',
    method: 'POST'
  };
  dom.ajax(
    opts, payload, ( err, res ) => {
      if ( err ) {
        onError();
        return;
      }
      acumen.track('web-submit-bring_me_starry');
      onSuccess( res );
    }
  );
}

function onError() {
  $error.classList.remove('hidden');
  $submit.disabled = false;
  $submit.classList.remove('loading');
}

function onSuccess() {
  $self.style.display = 'none';
  $thanks.style.display = 'block';
  if ( $banner ) {
    $banner.classList.add('is-visible');
    jump( $banner, { duration: 150 } );
  }
}

function isInvalid( inp ) {
  let validate = validators[ inp.dataset.validate ];
  return typeof validate === 'function' ?
    !validate( inp.value ) : isEmpty( inp );
}

function inputReducer( obj, inp ) {
  obj[ inp.name ] = inp.type === 'checkbox' ?
    inp.checked : ( inp.value || '' );
  return obj;
}

function validate() {
  return !$inputs
  .filter( shouldValidate )
  .map( removeError )
  .filter( isInvalid )
  .map( addError ).length;
}

function getPayload() {
  return $inputs
  .filter( isNotSubmit )
  .reduce( inputReducer, {} );
}

register( 'management-referral-form', init );

export default undefined;
